module.exports = __webpack_public_path__ + "static/img/连接器.3dd86d10.png";